import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import mask from '@alpinejs/mask';

// Initialize the Focus plugin
Alpine.plugin(focus);

// Initialize the Mask plugin
Alpine.plugin(mask);

window.Alpine = Alpine;

export function startAlpineOnce() {
  if (window.__HT_ALPINE_STARTED__) {
    return false;
  }

  // If another Alpine instance already initialized the DOM, do not start again.
  const initializedRoots = document.querySelectorAll('[x-data]');
  const alreadyInitialized = Array.from(initializedRoots).some((el) =>
    Boolean(el._x_marker || el._x_dataStack),
  );
  if (alreadyInitialized) {
    window.__HT_ALPINE_STARTED__ = true;
    return false;
  }

  try {
    Alpine.start();
    window.__HT_ALPINE_STARTED__ = true;
    return true;
  } catch (error) {
    const message = String(error?.message || '');
    // Defensive: another Alpine boot path initialized first.
    if (message.includes('Cannot redefine property: $nextTick')) {
      window.__HT_ALPINE_STARTED__ = true;
      return false;
    }
    window.__HT_ALPINE_STARTED__ = false;
    throw error;
  }
}
